<template>
  <div class="relative search-by-pic relative">
    <span class="iconfont font-40">&#xe763;</span>
    <input
      ref="camera"
      capture="camera"
      class="upload-input"
      type="file"
      accept="image/*"
      @change="handlerToUploadImg"
    />
  </div>
</template>

<script>
import { convertBase64UrlToBlob, prepareCanvas } from '@/utils/comUtils'
import { mcToast } from '@/utils/mcSdkUtils'
export default {
  name: 'commonSearchFace',
  components: {},
  props: {},
  data() {
    return {
      files: [],
      countImgId: 1,
      faceRect: null,
      canvasW: 120,
      canvasH: 120
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerToUploadImg(e) {
      let _files = e.target.files || e.dataTransfer.files || []
      if (_files && _files.length > 1) {
        return mcToast({ msg: '最多选择一张' })
      }
      // this.$refs.camera.value = ''
      let _file = _files[0]
      if (
        _file instanceof File &&
        (_file.type === 'image/png' ||
          _file.type === 'image/jpeg' ||
          _file.type === 'image/jpg')
      ) {
        let reader = new FileReader()
        reader.onload = () => {
          let image = new Image()
          image.src = reader.result
          image.crossOrigin = 'anonymous'
          image.onload = () => {
            let drawWidth = image.naturalWidth
            let drawHeight = image.naturalHeight
            let cvs = document.createElement('canvas')
            let ctx = cvs.getContext('2d')
            prepareCanvas(cvs, ctx, 120, 120)
            // 设置人脸裁剪初始开始坐标及范围
            // 调整裁剪范围扩大引起的裁剪坐标偏移量，x左移/y上移_scaleSize / 2个像素
            // 裁剪出人脸
            ctx.drawImage(image, 0, 0, drawWidth, drawHeight, 0, 0, 120, 120)
            this.$emit('change', {
              id: this.countImgId++,
              previewImgURL: cvs.toDataURL(),
              blob: convertBase64UrlToBlob(cvs.toDataURL()),
              size: '0,0,0,0'
            })
          }
        }
        reader.readAsDataURL(_file)
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
</style>
